var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',_vm._l((_vm.highlights),function({ count, rank, key, name }){return _c('StatCard',{key:key,staticClass:"span-4",attrs:{"title":name,"is-loading":_vm.isLoading}},[_vm._v("\n    "+_vm._s(_vm._f("numberFormatter")(count,2))+"\n    "),_c('FlexSpacer'),_vm._v("\n    "+_vm._s(_vm.getMedalEmojiFromRank(rank))+"\n  ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }